import { FC } from 'react'
import { Beat } from '@components/icons'
import { useUI } from '@components/ui/context'
import s from './CompetitorButton.module.scss'

const CompetitorButton: FC = () => {
  const { toggleCompetitor } = useUI()

  const handleCompetitorButton = () => {
    toggleCompetitor()
  }

  const calcItemsCount = () => {
    var checkitemarray = []
    var itemlist = localStorage.getItem('checklistCompetitor')
    if (itemlist) {
      var itemarray = itemlist.split('~')
      for (var i = 0; i < itemarray.length; i++) {
        if (itemarray[i].length > 2) {
          checkitemarray.push(itemarray[i])
        }
      }
    }
    return checkitemarray.length
  }
  var itemsCount = calcItemsCount()

  return (
    <div onClick={handleCompetitorButton} className={s['btn-wrap']} title="Beat Competitor's Price">
      <div className={s.btn}>
        <div className={s['cart-count-wrapper']}>
          <Beat />
          {itemsCount > 0 && (
            <span
              className={`${s['cart-count']} ${
                itemsCount > 99 ? ['cart-count-above-hundred'] : ''
              }`}
            >
              {itemsCount}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default CompetitorButton
